import React from 'react';

function Blog() {
  const blogPosts = [
    {
      title: 'How to Take Care of Plants',
      image: 'https://cdn.pixabay.com/photo/2018/09/01/03/49/flower-pot-3646013_640.jpg',
      alt: 'Healthy green plant in a decorative pot',
      desc: 'From watering schedules to sunlight tips, learn how to care for your plants the right way.',
    },
    {
      title: 'Choosing the Right Pot',
      image: 'https://images.pexels.com/photos/4503263/pexels-photo-4503263.jpeg',
      alt: 'Various stylish pots on a shelf with plants',
      desc: 'Find out which pots are best for your plants, decor, and lifestyle.',
    },
    {
      title: 'DIY Garden Decor Ideas',
      image: 'https://cdn.pixabay.com/photo/2016/04/08/13/52/daffodils-1316128_640.jpg',
      alt: 'Garden decorated with DIY daffodil decor',
      desc: 'Turn your garden into a cozy paradise with simple and fun DIY tips.',
    },
    {
      title: 'Indoor Gardening Tips',
      image: 'https://media.istockphoto.com/id/1147472170/photo/hand-with-water-can-watering-indoor-plants-on-windowsill.jpg?s=612x612&w=0&k=20&c=ebhi3cBpN-2mdq7x2a_U1VcI6sdZ2uhJDv38Z0AJuYM=',
      alt: 'Indoor plant in cozy home setting',
      desc: 'Learn how to create your own indoor jungle using light and layout tips.',
    },

  ];

  return (
    <section className="py-8 bg-gray-100" aria-labelledby="blog-heading">
      <div className="text-center mb-10">
        <h1 id="blog-heading" className="md:text-3xl text-2xl font-bold font-outfit text-green-700">Tips & Guides</h1>
        <p className="text-gray-600 mt-2 font-poppins">Helpful tips to care for your plants and home garden</p>
      </div>

      <div className="max-w-7xl  mx-auto grid gap-6 grid-cols-1  md:grid-cols-3 lg:grid-cols-4 px-6">
        {blogPosts.map((post, index) => (
          <article
            key={`blog-post-${index}`}
            className="bg-white  rounded-xl shadow-cardShadow hover:shadow-xl transition overflow-hidden flex flex-col h-full"
            role="article"
          >
            <img
              src={post.image}
              alt={post.alt}
              className="w-full h-44 object-cover card cursor-pointer"
              loading="lazy"
            />
            <div className="p-5 flex flex-col flex-1">
              <header>
                <h2 className="text-lg font-semibold mb-2 text-gray-800">{post.title}</h2>
              </header>
              <p className="text-gray-600 text-sm flex-1">{post.desc}</p>
           
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Blog;
